import React from 'react';

export function SingleCityRumor(props) {
	return (
		<li className="col-xlarge-4">
			<div className="blog-item">
				<h3 className="title">{props.data.title}</h3>
				<h4 className="date">{props.data.date.format('DD.MM.YYYY')}</h4>
				<div className="page-content">
					<p>{props.data.text}</p>
				</div>									
			</div>
		</li>
	);
}



// WEBPACK FOOTER //
// ./src/components/CityRumors/SingleCityRumor.js